import Grid from "@material-ui/core/Grid";
import withStyles from "@material-ui/core/styles/withStyles";
import { instance } from "Actions/AxiosInstance";
import ProfilePicture from "Component/Thumbnail/ProfilePicture";
import { withSnackbar } from "notistack";
import React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { getFormattedImageLink } from "Utils";

const styles = () => ({
  TableRow: {
    borderRadius: 4,
  },
});

class Preferences extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      Preferences: [],
    };
  }

  componentDidMount() {
    this.gePreferences();
  }

  gePreferences() {
    instance
      .post("perform/getemployeepreference", {
        participanttype: [1, 2, 3, 4, 5],
        employeeid: null,
      })
      .then((result) => {
        this.setState({
          Preferences: result.data.result,
        });
      })
      .catch((error) => {
        this.props.enqueueSnackbar(
          error.response ? error.response.data.error.message : error.message,
          { variant: "error" },
        );
      });
  }

  render() {
    const { Preferences } = this.state;
    return (
      <div>
        {/* <p className="normal-dark-secondary t-bold margin-bottom-16">
          Preferences
        </p> */}
        {Preferences.map((pref) => (
          <Grid container className="rounded-rectangle-div margin-bottom-16">
            <Grid item md={12} sm={12}>
              <p className="small-dark-secondary t-bold margin-bottom-8">
                {pref.participanttypename}
              </p>
            </Grid>
            {pref.preference.map((p) => (
              <Grid item md={3} sm={12}>
                <span className="margin-right-8">
                  <ProfilePicture
                    src={getFormattedImageLink(p.imagepath)}
                    height="24"
                  />
                </span>
                <span className="small-dark-secondary">{p.fullname}</span>
              </Grid>
            ))}
          </Grid>
        ))}
      </div>
    );
  }
}
const mapStateToProps = () => ({});

const mapDispatchToProps = (dispatch) => bindActionCreators({}, dispatch);

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withStyles(styles, { withTheme: true })(withSnackbar(Preferences)));
